import { ICartState } from '@msdyn365-commerce/global-state';
import { CommerceProperty } from '@msdyn365-commerce/retail-proxy';
import { ProductLineCommerceProperties } from '../utils';
import { getIsBuildParent, getItemProperty } from '../product/utils';

export async function removeBuildFromCart(cartState: ICartState, buildLineNumber: number): Promise<void> {
    const linesToRemove: string[] | undefined = cartState.cart?.CartLines?.filter(cl => {
        if (!cl.LineId) {
            return false;
        }

        const isBuildParent: boolean = getIsBuildParent(cl);
        const isBuildItem: boolean = getItemProperty(cl, ProductLineCommerceProperties.isBuildLine)?.BooleanValue ?? false;

        if (isBuildParent && cl.LineNumber === buildLineNumber) {
            return true;
        }

        const parentLineNumber: number =
            cl.ExtensionProperties?.find(
                (commerceProp: CommerceProperty) => commerceProp.Key === ProductLineCommerceProperties.buildParentLineNumber
            )?.Value?.DecimalValue ?? -1;

        return isBuildItem && parentLineNumber === buildLineNumber;
    }).map(cl => cl.LineId!);

    if (linesToRemove && linesToRemove.length > 0) {
        cartState.removeCartLines({ cartLineIds: linesToRemove });
    }
}
